"use client";

import { useGlobalTranscriptionStatus } from "@medimo/global-state";
import { reportError } from "@medimo/monitor";
import * as logger from "@medimo/monitor/logger";
import { Alert, AlertDescription, AlertTitle, Button } from "@medimo/ui";
import Link from "next/link";
import { useEffect } from "react";
import { CONTACT_FORM_LINK } from "./config";

type GlobalErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalErrorPage({ error }: GlobalErrorPageProps) {
  useEffect(() => {
    // console.error は forwardConsoleLogs で二重送信になるため使わず、
    // Logs(発生時刻の特定用)と RUM(SLO集計用)へ明示的に送る
    logger.error(
      "globalError:caught",
      {
        digest: error.digest,
        transcriptionStatus: useGlobalTranscriptionStatus.getState().status,
      },
      error,
    );
    reportError(error);
  }, [error]);

  return (
    <html>
      <body className="flex min-h-screen items-center px-4 py-12 sm:px-6 md:px-8 lg:px-12 xl:px-16">
        <div className="w-full space-y-6 text-center">
          <div className="space-y-3">
            <h1 className="font-bold text-4xl tracking-tighter transition-transform hover:scale-110 sm:text-5xl">
              エラー
            </h1>
            <p className="text-gray-500">
              エラーが発生しました。お手数ですが、再度お試しください。
            </p>
            <Alert>
              <AlertTitle>エラーメッセージ</AlertTitle>
              <AlertDescription>{error.message}</AlertDescription>
            </Alert>
          </div>
          <div className="flex flex-1 justify-center gap-3">
            <Button variant="outline" asChild>
              <Link
                href={CONTACT_FORM_LINK}
                prefetch={false}
                target="_blank"
                rel="noreferrer"
              >
                問い合わせる
              </Link>
            </Button>
            <Button asChild>
              <Link href="/" prefetch={false}>
                ホームに戻る
              </Link>
            </Button>
          </div>
        </div>
      </body>
    </html>
  );
}
